import { useState } from "react";
import { Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { PageHeader, Field, SimpleSelect, Table, Th, Td, Tr, Empty } from "@/components/common";
import { useApi, act } from "@/lib/useApi";
import { api } from "@/lib/api";
import { dtTime } from "@/lib/fmt";

const KINDS = { contrato: "Contrato", termo_responsabilidade: "Termo de responsabilidade", lgpd: "Consentimento LGPD", imagem: "Uso de imagem" };

export default function Contracts() {
  const [tpls, reload] = useApi("/contracts/templates");
  const [acc] = useApi("/contracts/acceptances");
  const [open, setOpen] = useState(false);
  const [f, setF] = useState({ title: "", kind: "contrato", content: "" });
  const save = async () => { const r = await act(() => api.post("/contracts/templates", f), "Nova versão publicada"); if (r) { setOpen(false); reload(); } };
  return (
    <div>
      <PageHeader eyebrow="Aceite eletrônico" title="Contratos e termos">
        <Button className="bg-red-600 hover:bg-red-700" onClick={() => setOpen(true)} data-testid="new-template-btn"><Plus className="w-4 h-4 mr-1" />Nova versão</Button>
      </PageHeader>
      <div className="grid lg:grid-cols-2 gap-4 mb-6">
        {(tpls || []).map((t) => (
          <div key={t.id} className={`panel p-5 ${!t.active && "opacity-50"}`} data-testid={`template-${t.id}`}>
            <div className="eyebrow">{KINDS[t.kind]} · versão {t.version} {t.active ? "· vigente" : "· substituída"}</div>
            <div className="font-display text-xl font-bold uppercase mt-1">{t.title}</div>
            <pre className="mt-3 whitespace-pre-wrap text-xs text-slate-600 max-h-40 overflow-y-auto font-sans">{t.content}</pre>
            <div className="font-mono text-[10px] text-slate-400 mt-2">sha256 {t.content_hash.slice(0, 24)}… · {dtTime(t.created_at)}</div>
          </div>))}
      </div>
      <div className="panel"><div className="p-4 font-display text-lg font-bold uppercase">Aceites registrados</div>
        {!acc?.length ? <Empty /> : <Table testid="acceptances-table"><thead><tr><Th>Aluno</Th><Th>Documento</Th><Th>Versão</Th><Th>Aceito por</Th><Th>Método</Th><Th>Data</Th></tr></thead>
          <tbody>{acc.map((a) => <Tr key={a.id}><Td className="font-semibold">{a.student_name}</Td><Td>{a.title}</Td><Td>v{a.version}</Td><Td>{a.accepted_by_name} <span className="text-xs text-slate-500">({a.accepted_by_role})</span></Td>
            <Td className="capitalize">{a.method}</Td><Td>{dtTime(a.accepted_at)}</Td></Tr>)}</tbody></Table>}</div>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-2xl" data-testid="template-dialog">
          <DialogHeader><DialogTitle className="font-display text-2xl uppercase">Publicar nova versão</DialogTitle></DialogHeader>
          <div className="space-y-3">
            <Field label="Tipo"><SimpleSelect value={f.kind} onChange={(v) => setF({ ...f, kind: v })} testid="template-kind-select" options={Object.entries(KINDS).map(([value, label]) => ({ value, label }))} /></Field>
            <Field label="Título"><Input value={f.title} onChange={(e) => setF({ ...f, title: e.target.value })} data-testid="template-title-input" /></Field>
            <Field label="Texto integral"><Textarea rows={12} value={f.content} onChange={(e) => setF({ ...f, content: e.target.value })} data-testid="template-content-input" /></Field>
            <p className="text-xs text-slate-500">A versão anterior do mesmo tipo deixa de ser vigente; aceites antigos permanecem registrados com a versão aceita.</p>
            <Button onClick={save} className="w-full bg-red-600 hover:bg-red-700" data-testid="template-save-btn">Publicar</Button>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
}
